import styled from 'styled-components';
import _ReactModal from 'react-modal';
import { normalize } from 'utils/styles';
import { color } from 'styles/settings';

export const ReactModal = styled(_ReactModal)`
  outline: none;
  border-radius: ${normalize('10px')};
  background-color: ${color.neutral.white};
  width: 50%;
  min-width: 440px;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  padding: ${normalize('20px')};
  transform: translateX(-50%) translateY(-50%);
  overflow: hidden;
  position: relative;
  border: none;
  z-index: 1000;

  @media all and (max-width: 1200px) {
    width: 80%;
  }
`;
